// extracted by mini-css-extract-plugin
export default {"section":"RentACar_section__MI7P0"};